import { createSlice } from "@reduxjs/toolkit";
import { getLocalStorage } from "../../Utils/storage-utils";
import { newSidebarRoutes } from "../Sidebar/NavLink";

const defaultSidebarKey = "DASHBOARD*ALARM_DASHBOARD";
const getInitSelectedKey = () => {
  const stored_key = getLocalStorage("storage_sidebar_key");
  return stored_key ?? defaultSidebarKey;
};

const getInitialState = () => ({
  extentedSidebar: false,
  selectedSidebarKey: getInitSelectedKey(),
});

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: getInitialState(),
  reducers: {
    updateExtentedSidebar: (state, action) => {
      state.extentedSidebar = action.payload;
    },
    updateSelectedSidebarKey: (state, action) => {
            localStorage.setItem("storage_sidebar_key", action.payload);
      state.selectedSidebarKey = action.payload;
    },
    resetSidebar: (state, action) => {
      localStorage.setItem("storage_sidebar_key", defaultSidebarKey);
      state.selectedSidebarKey = defaultSidebarKey;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateExtentedSidebar, updateSelectedSidebarKey, resetSidebar } = sidebarSlice.actions;
export const selectSidebarKey = (state) => state.sidebar.selectedSidebarKey;
export const selectedExtentedSidebar = (state) => state.sidebar.extentedSidebar;
export default sidebarSlice.reducer;
